import { MeasurementCategory } from 'ui/enums';

export const MeasurementCategoryIconMap: Record<MeasurementCategory, string> = {
  [MeasurementCategory.Time]: 'clock',
  [MeasurementCategory.Weight]: 'target_and_arrow',
  [MeasurementCategory.CustomUnit]: 'target_and_arrow',
  [MeasurementCategory.Completion]: 'target_and_arrow',
};
